import { Box, Card, CardActionArea, Typography } from '@mui/material';
import ArrowForward from '@mui/icons-material/ArrowForward';
import { Link } from 'react-router-dom';
import { navigationGroups } from '../../config/navigation';
import { useAdminText } from './useAdminText';

export function WorkspaceLinks() {
  const t = useAdminText();
  const items = navigationGroups.flatMap(group => group.items).filter(item => ['users', 'support', 'subscriptions', 'cron'].includes(item.id));
  return <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', xl: 'repeat(4, 1fr)' }, gap: 1.5, mb: 3 }}>
    {items.map(item => <Card key={item.id}><CardActionArea component={Link} to={item.path} sx={{ display: 'flex', p: 2, gap: 1.5, minHeight: 80 }}>
      <item.icon color="primary" />
      <Typography variant="body2" fontWeight={700} sx={{ flex: 1 }}>{t(`navigation.${item.id}`, item.label)}</Typography>
      <ArrowForward fontSize="small" sx={{ color: 'text.secondary' }} />
    </CardActionArea></Card>)}
  </Box>;
}
